import React, { useEffect, useRef, useState } from "react";

import { IProfile } from "./interface";
import ModalSelectProfile from "./ModalSelectProfile";
import * as S from "./styles";
import ArrowDown from "../../assets/svg/arrow-down.svg";
import ArrowUp from "../../assets/svg/arrow-up.svg";

export const ProfileMenu: React.FC<{
  profiles: IProfile[];
  handleSelectProfile: (profile: any) => void;
  selected: {
    title: string;
    profileName: string;
    id: number;
  } | null;
}> = ({ profiles, selected, handleSelectProfile }) => {
  const [showSelector, setShowSelector] = useState(false);
  const statusRef = useRef<any>(null);

  useEffect(() => {
    const handleDocumentClick = (e: any) => {
      if (statusRef.current && !statusRef.current.contains(e.target)) {
        setShowSelector(false);
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [showSelector, statusRef]);

  return (
    <S.Container ref={statusRef}>
      <S.ContainerSelected>
        <S.SelectedTitle>{`${selected?.title} - ${selected?.profileName}`}</S.SelectedTitle>
        <S.ChevronButton onClick={() => setShowSelector(!showSelector)}>
          <img
            className="icon"
            src={showSelector ? ArrowUp : ArrowDown}
            alt=""
          />
        </S.ChevronButton>
      </S.ContainerSelected>
      {showSelector && profiles.length > 0 ? (
        <ModalSelectProfile
          handleSelectProfile={handleSelectProfile}
          profiles={profiles}
          selected={selected}
          setShowSelector={setShowSelector}
        />
      ) : null}
    </S.Container>
  );
};
